import {Pattern} from '../types/Pattern';

export const getRawStartingNumber = (
  pattern: Omit<Pattern, 'from' | 'startingNumber'> & {startingNumber: number | string}
) => {
  const prefix = pattern.prefix?.trim() || '';

  return String(pattern.startingNumber).substring(prefix.length).replaceAll(/^0+/g, '');
};
